/*
 * layout.module.js
 *
 */
(function() {
    'use strict';

    angular
        .module('app.layout', [
            'app.core'
        ]);

})();
/*
 * layout.config.js
 */
(function() {
    'use strict';

    angular
        .module('app.layout')
        .config(configLayout);

    configLayout.$inject = ['$translatePartialLoaderProvider'];

    /* @ngInject */
    function configLayout($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('layout');
    }

})();
/*
 * app-layout.component.js
 */
(function() {
    'use strict';

    angular
        .module('app.layout')
        .component('appLayout', {
            controller: AppLayoutController,
            templateUrl: 'app/layout/app-layout.html'
        });

    // COMPONENT - Controller
    AppLayoutController.$inject = [];
    /* @ngInject */
    function AppLayoutController() {
        var $ctrl = this;

        $ctrl.$onInit = onInit;

        ////////////

        function onInit() {}

    }

})();
/*
 * app-footer.component.js
 */
(function() {
    'use strict';

    angular
        .module('app.layout')
        .component('app900Footer', {
            controller: App900FooterController,
            templateUrl: 'app/layout/app-900-footer.html',
            bindings: {}
        });

    App900FooterController.$inject = ['moment'];

    /* @ngInject */
    function App900FooterController(moment) {
        var $ctrl = this;

        $ctrl.$onInit = onInit;

        ////////////

        function onInit() {
            $ctrl.currentYear = moment().year();
        }
    }

})();
/*
 * app-header.component.js
 */
(function() {
    'use strict';

    angular
        .module('app.layout')
        .component('app100TopNavbar', {
            controller: App100TopNavbarController,
            bindings: {},
            templateUrl: 'app/layout/app-102-top-navbar.html'
        });

    App100TopNavbarController.$inject = ['$translate', 'LanguageService', 'activateSiteTranslate'];

    /* @ngInject */
    function App100TopNavbarController($translate, LanguageService, activateSiteTranslate) {
        var $ctrl = this;

        $ctrl.manageLang = undefined;
        $ctrl.isMenuCollapsed = true;

        $ctrl.$onInit = onInit;
        $ctrl.setLang = setLang;

        ////////////

        function onInit() {
            var hasPreferred = LanguageService.getPreferred();
            if (hasPreferred.length > 0) {
                setLang(hasPreferred);
            }
            $ctrl.manageLang = activateSiteTranslate;
        }

        function setLang(lang) {
            $translate.use(lang);
        }
    }

})();
/*
 * core.module.js
 */
(function() {
    'use strict';

    angular
        .module('app.core', [
            'ngAria',
            'ngAnimate',
            'ngCookies',
            'ngSanitize',
            'ngMessages',

            'ui.router',
            'ui.bootstrap',
            'ui.validate',
            'restangular',
            'ngTable',
            'pascalprecht.translate',
            'jcs-autoValidate',
            'angular.filter',

            'ng-currency'

        ]);

})();
/*
 * ng-table.run.js
 *
 * Parametri di configurazione per standardizzare le istanze
 * della ng-table
 * 
 */
(function() {
    'use strict';

    angular
        .module('app.core')
        .run(extendsNgTableParams);

    extendsNgTableParams.$inject = ['NgTableParams', '_'];

    /* @ngInject */
    function extendsNgTableParams(NgTableParams, _) {
        NgTableParams.fromUiStateParams = function(state, defaults, settings, prefix) {
            var stateToKeep = {};

            if (angular.isDefined(prefix)) {
                // Transform state params in order to extract only those with prefix and hide others
                stateToKeep = _.omitBy(state, function(value, key) {
                    return _.startsWith(key, prefix);
                });
                state = _.mapKeys(_.pickBy(state, function(value, key) {
                    return _.startsWith(key, prefix);
                }), function(value, key) {
                    return key.substring(prefix.length);
                });
            }

            var params = _.merge({}, defaults, state);

            Object.keys(params).forEach(function(key) {
                if (key !== 'page' && key !== 'count' && key !== 'sort') {
                    params['filter[' + key + ']'] = params[key];
                    delete params[key];
                }
            });

            if (params.sort) {
                if (!angular.isArray(params.sort)) {
                    params.sort = [params.sort];
                }
                params.sort.forEach(function(sort) {
                    var parts = sort.split(',');
                    params['sorting[' + parts[0] + ']'] = parts[1];
                });
                delete params.sort
            }
            params = new NgTableParams(params, settings);
            params.__stateToKeep = stateToKeep;
            return params;
        };

        NgTableParams.prototype.uiRouterUrl = function(prefix) {
            var params = this.url() || {};

            Object.keys(params).forEach(function(key) {
                var match = key.match(/^sorting\[([^\]]+)]$/);
                if (match) {
                    params.sort = params.sort || [];
                    params.sort.push(match[1] + "," + params[key]);
                    delete params[key];
                } else {
                    match = key.match(/^filter\[([^\]]+)]$/)
                    if (match) {
                        params[match[1]] = params[key]
                        delete params[key];
                    }
                }
            });

            if (angular.isDefined(prefix)) {
                // Prefix all the parameters with provided prefix.
                params = _.mapKeys(params, function(value, key) {
                    return prefix + key;
                });
            }

            params = _.merge(params, this.__stateToKeep);

            return params;
        };
    }

})();
/*
 * core.run.js
 */
(function() {
    'use strict';

    angular
        .module('app.core')
        .run(runCore);

    // TODO
    // magari il portletId non serve a niente

    runCore.$inject = ['validator', '$trace'];

    /* @ngInject */
    function runCore(validator, $trace) {
        validator.setValidElementStyling(false);
        $trace.enable('TRANSITION');
    }

})();
/*
 * core.constants.js
 */
/* global _ moment */
(function() {
    'use strict';

    angular
        .module('app.core')
        .constant('_', _)
        .constant('moment', moment)
        .constant('contextAddress', 'assets/data/')
        .constant('imagesAddress', 'assets/images/')
        .constant('activateSiteTranslate', false)
        .constant('drugTypes', {
            CAPS: { desc: 'CAPS', ico: 'fa-capsules' },
            TABLETS: { desc: 'TABLETS', ico: 'fa-tablets' },
            INJECT: { desc: 'INJECT', ico: 'fa-syringe' },
            SYRUP: { desc: 'SYRUP', ico: 'fa-flask' }            
        })
        .constant('weekDays', [
            { "desc": "Lunedì", "abbr": "Lun", "idx": 1 },
            { "desc": "Martedì", "abbr": "Mar", "idx": 2 },
            { "desc": "Mercoledì", "abbr": "Mer", "idx": 3 },
            { "desc": "Giovedì", "abbr": "Gio", "idx": 4 },
            { "desc": "Venerdì", "abbr": "Ven", "idx": 5 },
            { "desc": "Sabato", "abbr": "Sab", "idx": 6 },
            { "desc": "Domenica", "abbr": "Dom", "idx": 0 },
        ])
        .constant('weekDaysINTL', [
            'MON',
            'TUE',
            'WED',
            'THU',
            'FRI',
            'SAT',
            'SUN'
        ])
        .constant('eventsName', 'events-schedule.json')
        .provider('resourceUrl', resourceUrlProvider);

    resourceUrlProvider.$inject = [];

    /* @ngInject */
    function resourceUrlProvider() {
        return {
            $get: function() {
                var baseURL = "";
                return baseURL;
            }
        };
    }

})();
/*
 * core.config.js
 */
(function() {
    'use strict';

    angular
        .module('app.core')
        .config(config)
        .config(cfgHtml5Mode)
        .config(configureRestangular);

    config.$inject = ['$translateProvider', '$translatePartialLoaderProvider', '$urlRouterProvider', '$uibTooltipProvider', 'resourceUrlProvider'];

    /* @ngInject */
    function config($translateProvider, $translatePartialLoaderProvider, $urlRouterProvider, $uibTooltipProvider, resourceUrlProvider) {
        $translatePartialLoaderProvider.addPart('core');
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: resourceUrlProvider.$get() + 'app/{part}/i18n/{lang}.json'
        });
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
        $translateProvider.preferredLanguage('it');

        $urlRouterProvider.otherwise('/home');

        $uibTooltipProvider.options({
            appendToBody: true
        });
    }

    cfgHtml5Mode.$inject = ['$locationProvider'];

    /* @ngInject */
    function cfgHtml5Mode($locationProvider) {
        $locationProvider.html5Mode(true);
    }

    configureRestangular.$inject = ['RestangularProvider'];

    /* @ngInject */
    function configureRestangular(RestangularProvider) {
        RestangularProvider.addResponseInterceptor(function(data, operation, what, url, response) {
            if (operation === 'post' && response.status === 201) {
                var location = response.headers('Location');
                if (location) {
                    return location.substr(location.lastIndexOf('/') + 1);
                }
                return response;
            }
            return data;
        });
    }

})();
/*
 * config.service.js
 */
(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('LanguageService', LanguageService)
        .factory('EventsService', EventsService)
        .factory('DrugsService', DrugsService);

    /* @ngInject */
    LanguageService.$inject = [];

    /* @ngInject */
    function LanguageService() {
        var service = {
            getPreferred: getPreferred
        };
        return service;

        //////////////////////////

        function getPreferred() {
            return 'it';
        }
    }

    /* @ngInject */
    EventsService.$inject = ['$http', 'contextAddress'];


    /* @ngInject */
    function EventsService($http, contextAddress) {
        var service = {
            getList: getList
        };
        return service;

        //////////////////////////

        function getList() {
            return $http.get(contextAddress + 'test-data.json')
                .then(function (list) {
                    return list.data;
                });
        }
    }

    /* @ngInject */
    DrugsService.$inject = ['$http', 'contextAddress', 'weekDays', 'eventsName'];

    /* @ngInject */
    function DrugsService($http, contextAddress, weekDays, eventsName) {
        var service = {
            getDrug: getDrug,
            getDrugs: getDrugs,
            getWeekDay: getWeekDay,
            getEvents: getEvents
        };
        return service;

        //////////////////////////

        function getDrug(id) {
            return $http.get(contextAddress + 'drugs.json')
                .then(function (list) {
                    // ritornare l'elemento filtrato con lodash
                    var find = _.find(list.data, { 'id': id });
                    return find;
                });
        }
        function getDrugs() {
            return $http.get(contextAddress + 'drugs.json')
                .then(function (list) {
                    return list.data;
                });
        }

        function getWeekDay(id) {
            // prendere dalla costante con l'id di tre lettere
            return $http.get(contextAddress + 'drugs.json')
            .then(function (list) {
                // ritornare l'elemento filtrato con lodash
                return _.find(list, { 'id': id });
            });
        }

        function getEvents(username) {
            // TO DO
            // Check if user's file exists, before calling the $http
            return $http.get(contextAddress + username + '_events-schedule.json')
                .then(function (list) {
                    return list.data;
                });
        }

    }
})();
/*
 * app.js.js
 */
(function() {
    'use strict';

    angular
        .module('app', [

            // Configurazione iniziale e generale dell'app
            'app.core',

            // TO-DO Commons
            // 'app.cs-components',
            /*
            'blocks.notifications',
            'blocks.alerts',
            */

            // Layout dell'applicazione
            'app.layout',
            'app.home-page',
            'app.schedule-page'
        ]);

})();
/*
 * schedule-page.module.js
 *
 */
(function() {
    'use strict';

    angular
        .module('app.schedule-page', [
            'app.core'
        ])
        .config(configAndRoutingGeneration)
        .component('schedulePage', {
            controller: SchedulePageController,
            templateUrl: 'app/schedule-page/schedule-page.html',
            bindings: {
                // cmsDrugs: '<',
                drugs: '<',
                username: '<',
                userSchedule: '<'
            }
        });

    // CONFIG - internationalization and area routing
    configAndRoutingGeneration.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /* @ngInject */
    function configAndRoutingGeneration($translatePartialLoaderProvider, $stateProvider) {

        // i18n - Intl
        $translatePartialLoaderProvider.addPart('schedule-page');

        // Routing
        $stateProvider.state('schedules', {
            url: '/schedules',
            abstract: true,
            template: '<ui-view/>'
        })
        .state('schedules.username', {
            url: '/{username}',
            component: 'schedulePage',
            resolve: {
                // cmsDrugs: ['HeadlessCmsService', function(HeadlessCmsService) {
                //     return HeadlessCmsService.getEntries('medicineDrugs');
                // }],
                drugs: ['DrugsService', function(DrugsService) {
                    return DrugsService.getDrugs();
                }],
                username: ['$transition$', function($transition$) {
                    return $transition$.params().username
                }],
                userSchedule: [ 'DrugsService', '$transition$', function(DrugsService, $transition$) {
                    // $transition$.params().username
                    return DrugsService.getEvents($transition$.params().username);
                }]
            }
        });
    }
    // COMPONENT - Controller
    SchedulePageController.$inject = ['$document', 'moment', 'EventsService', 'DrugsService', 'weekDays', 'drugTypes'];
    /* @ngInject */
    function SchedulePageController($document, moment, EventsService , DrugsService, weekDays, drugTypes) {
        var $ctrl = this;
        $ctrl.currDay = undefined;
        $ctrl.weekStart = undefined;
        $ctrl.weekEnd = undefined;

        $ctrl.$onInit = onInit;
        $ctrl.isToday = isToday;

        ////////////

        function onInit() {

            $ctrl.currDay = moment.utc();
            $ctrl.finalEvents = [];
            _generateWeek();

            _dbg();
        }

        function isToday(dt) {
            return moment.utc(dt).isSame( moment.utc(), 'day');
        }

        function _dbg() {
            console.log("User Schedule Page Ctrl", $ctrl);
        }

        function _generateWeek() {
            $ctrl.weekStart = moment.utc().startOf('week');
            $ctrl.endStart = moment.utc().endOf('week');
            var nextDay = moment.utc().startOf('week');
            nextDay = moment.utc($ctrl.weekStart).add(1, 'days');

            _.forEach(weekDays, function(val, key) {
                var currDay = {
                    id: val.idx,
                    date: nextDay,
                    desc: val.desc,
                    abbr: val.abbr,
                    active: $ctrl.isToday(nextDay),
                    weekday: nextDay.day(),
                    day: nextDay.date(),
                    month: nextDay.format('MMM'),
                    year: nextDay.year(),
                    eventsOfTheDay: _genCalendar(nextDay)
                };
                $ctrl.finalEvents.push(currDay);
                var prevDate = moment.utc(nextDay);
                nextDay = moment.utc(nextDay).add(1, 'days');
            });

        }

        function _genCalendar(currDt) {
            var userDayEvents = [];

            _.each($ctrl.userSchedule, function(val, key) {
                var currFarmaco = _.find($ctrl.drugs, { 'id': val.farmaco });
                // console.log("Farmaco", currFarmaco);

                _.filter(val.eventi, function(obj) {
                    if ( 
                        // la data del giorno che processo è compresa nel range impostato dall'evento
                        moment.utc(currDt).isBetween(moment.utc(obj.dataInizio), moment.utc(obj.dataFine), 'day', '[]') 
                        // il giorno che processo è compreso tra i giorni della settimana impostati
                        && obj.giorni.includes(moment.utc(currDt).day())
                        // il giorno che processo NON deve essere presente tra i giorni da esludere
                        && !(obj.giorniDaEscludere.includes( moment.utc(currDt).format('YYYY-MM-DD') ) )
                    ) {
                        _.each( obj.orari, function(dTime) {
                            userDayEvents.push({
                                time: dTime,
                                farmaco: currFarmaco.name,
                                alternateName: currFarmaco.alternateName,
                                stomacoPieno: currFarmaco.stomacoPieno,
                                tipologia: drugTypes[currFarmaco.tipologia]
                            });
                        })
                    }
                });
            });

            return _.orderBy(userDayEvents, ['time'], ['asc']);
        }

    }

})();
/*
 * home-page.module.js
 *
 */
(function() {
    'use strict';

    angular
        .module('app.home-page', [
            'app.core'
        ])
        .config(configAndRoutingGeneration)
        .component('homePage', {
            controller: HomePageController,
            templateUrl: 'app/home-page/home-page.html',
            bindings: {
                eventsList: '<',
                drugs: '<'
            }
        });

    // CONFIG - internationalization and area routing
    configAndRoutingGeneration.$inject = ['$translatePartialLoaderProvider', '$stateProvider'];
    /* @ngInject */
    function configAndRoutingGeneration($translatePartialLoaderProvider, $stateProvider) {

        // i18n - Intl
        $translatePartialLoaderProvider.addPart('home-page');

        // Routing
        $stateProvider.state('homepage', {
            url: '/home',
            component: 'homePage',
            resolve: {
                eventsList: [ 'EventsService', function(EventsService) {
                    return EventsService.getList();
                }],
                drugs: ['DrugsService', function(DrugsService) {
                    return DrugsService.getDrugs();
                }]
            }
        });
    }

    // COMPONENT - Controller
    HomePageController.$inject = ['$document', 'moment', 'EventsService', 'DrugsService' /* '$q', '$window', '_' */ ];
    /* @ngInject */
    function HomePageController($document, moment, EventsService , DrugsService /*$q, $window, _ */ ) {
        var $ctrl = this;
        $ctrl.refDate = '2021-02-20';

        $ctrl.$onInit = onInit;
        $ctrl.getDrug = getDrug;

        ////////////

        function onInit() {
            _.forEach($ctrl.eventsList, function(v,k) {
                v.inizioUTC = moment.utc(v.start);
                v.fineUTC = moment.utc(v.end);
                v.refDateUTC = moment.utc($ctrl.refDate);
                v.isInRange = moment.utc($ctrl.refDate).isBetween(v.inizioUTC, v.fineUTC, 'day','[]');
                //v.isInRange = moment.utc($ctrl.refDate).isBetween(v.inizioUTC, v.fineUTC, 'day', '[]');
            });

            _dbg();

        }

        function getDrug(id) {
            return _.find($ctrl.drugs, { "id": id });
        }


        function _dbg() {
            $ctrl.t = DrugsService.getDrug(2);
            console.log("Med 2", $ctrl.getDrug(2) );
            //console.log($ctrl.testDrugSearch.name);
            console.log("Ctrl", $ctrl);
        }

    }

})();
angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/home-page/home-page.html","<div class=container><div class=jumbotron><h1>Internal Mockups</h1><p>Solo a scopo dimostrativo</p></div><div class=row><div class=col><h3>Data di riferimento: {{ $ctrl.refDate }}</h3><h3>Medicinale {{ $ctrl.t }}</h3><table class=table><thead><tr><th>Desc Evento</th><th>start</th><th>end</th><th>start UTC</th><th>end UTC</th><th>refDate</th><th>is in range</th></tr></thead><tbody><tr ng-repeat=\"event in $ctrl.eventsList\"><td>{{ event.desc }}</td><td>{{ event.start }}</td><td>{{ event.end }}</td><td>{{ event.inizioUTC }}</td><td>{{ event.fineUTC }}</td><td>{{ event.refDateUTC }}</td><td ng-class=\"{ \'bg-success\': event.isInRange, \'bg-danger\': !event.isInRange }\">Esito</td></tr></tbody></table></div></div><div class=\"card border-dark mb-3\"><div class=card-header>header title</div><div class=\"card-body text-dark\"><h4 class=card-title>internal title</h4><p class=card-text>Text <i class=\"fas fa-syringe\"></i></p></div><div class=\"card-footer text-muted\">Footer text</div></div></div>");
$templateCache.put("app/layout/app-100-top-navbar.html","<nav class=\"navbar navbar-inverse navbar-static-top navbar-fixed-top\" data-translate-namespace=AppSkeleton><div class=container><!-- Brand and toggle get grouped for better mobile display --><div class=navbar-header><button type=button class=\"navbar-toggle collapsed\" data-toggle=collapse data-target=#app-top-navbar aria-expanded=false aria-controls=navbar><span class=sr-only translate>.TopNavBar.ToggleNav</span> <span class=icon-bar></span> <span class=icon-bar></span> <span class=icon-bar></span></button> <a class=navbar-brand ui-sref=homepage translate>.TopNavBar.BrandTitle</a></div><!-- Collect the nav links, forms, and other content for toggling --><div id=app-top-navbar class=\"navbar-collapse collapse\" aria-expanded=false><ul class=\"nav navbar-nav navbar-right\"><li ui-sref-active=homepage><a ui-sref=homepage translate>HomePage.PageLinkDescription</a></li><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false><span translate>.TopNavBar.Areas.KitchenSink.Description</span> <span class=caret></span></a><ul class=dropdown-menu><li ui-sref-active=kitchen-sink><a ui-sref=kitchen-sink translate>.TopNavBar.Areas.KitchenSink.Home.desc</a></li></ul></li><li class=dropdown><a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false><span translate>.TopNavBar.Areas.NewCrm.Description</span> <span class=caret></span></a><ul class=dropdown-menu><li ui-sref-active=new-crm.color-palettes><a ui-sref=new-crm.color-palettes translate>.TopNavBar.Areas.NewCrm.ColorsPalette.desc</a></li><li><a ui-sref=new-crm.login-forms translate>.TopNavBar.Areas.NewCrm.LoginPages.desc</a></li></ul></li><li class=dropdown ng-if=$ctrl.manageLang><a class=dropdown-toggle data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false><span translate>.TopNavBar.LanguageChooser</span> <span class=caret></span></a><ul class=dropdown-menu><li><a href=\"\" ng-click=\"$ctrl.setLang(\'it\')\" translate>.TopNavBar.Langs.Italian</a></li><li><a href=\"\" ng-click=\"$ctrl.setLang(\'en\')\" translate>.TopNavBar.Langs.English</a></li></ul></li></ul><!-- language selector --><ul class=\"nav navbar-nav navbar-right\"></ul><!-- /.navbar-vav Language --></div><!-- /.navbar-collapse --></div><!-- /.container-fluid --></nav>");
$templateCache.put("app/layout/app-101-top-navbar.html","<nav class=\"navbar navbar-expand-md navbar-dark bg-dark\"><div class=container><a class=navbar-brand href=#>Navbar</a> <button class=\"navbar-toggler d-lg-none\" type=button data-toggle=collapse data-target=#collapsibleNavId aria-controls=collapsibleNavId aria-expanded=false aria-label=\"Toggle navigation\"></button><div class=\"collapse navbar-collapse\" id=collapsibleNavId><ul class=\"navbar-nav mr-auto mt-2 mt-lg-0\"><li class=\"nav-item active\"><a class=nav-link ui-sref=homepage ui-sref-active>Home <span class=sr-only>(current)</span></a></li><li class=nav-item><a class=nav-link ui-sref=\"schedules.username({ username: \'mbutomax\' })\" ui-sref-active>Mbuto Sched</a></li><li class=\"nav-item dropdown\"><a class=\"nav-link dropdown-toggle\" href=# id=dropdownId data-toggle=dropdown aria-haspopup=true aria-expanded=false>Dropdown</a><div class=dropdown-menu aria-labelledby=dropdownId><a class=dropdown-item href=#>Action 1</a> <a class=dropdown-item href=#>Action 2</a></div></li></ul><form class=\"form-inline my-2 my-lg-0\"><input class=\"form-control mr-sm-2\" type=text placeholder=Search> <button class=\"btn btn-outline-success my-2 my-sm-0\" type=submit>Search</button></form></div></div></nav>");
$templateCache.put("app/layout/app-102-top-navbar.html","<nav class=\"navbar navbar-expand-md navbar-dark bg-dark\" role=navigation><div class=container><a class=navbar-brand ui-sref=homepage>FunnelDrugs</a> <button class=\"navbar-toggler d-lg-none\" type=button data-toggle=collapse data-target=#collapsibleNavId aria-controls=collapsibleNavId aria-expanded=false aria-label=\"Toggle navigation\" ng-click=\"$ctrl.isMenuCollapsed = !$ctrl.isMenuCollapsed\"><span class=navbar-toggler-icon></span></button><div class=\"collapse navbar-collapse\" id=collapsibleNavId uib-collapse=$ctrl.isMenuCollapsed><ul class=\"navbar-nav mr-auto mt-2 mt-lg-0\"><li class=nav-item><a class=nav-link ui-sref=homepage ui-sref-active>Home <span class=sr-only>(current)</span></a></li><li class=nav-item><a class=nav-link ui-sref=\"schedules.username({ username: \'mbutomax\' })\" ui-sref-active>Mbuto Sched</a></li></ul></div></div></nav>");
$templateCache.put("app/layout/app-900-footer.html","<footer data-translate-namespace=AppSkeleton.Footer><div class=container-fluid><div class=\"row row-credits\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=text-center><small><i class=\"fa fa-copyright\"></i> Copyright 1997 - {{ $ctrl.currentYear }} [Massimiliano Sini] - <a href=\"\">Privacy [todo]</a> - <a href=\"\">Term of use [todo]</a></small></div></div></div></div></footer>");
$templateCache.put("app/layout/app-layout.html","<app-100-top-navbar></app-100-top-navbar><!-- contenuto della SPA --><div id=app-main-row><ui-view></ui-view></div><app-900-footer></app-900-footer>");
$templateCache.put("app/schedule-page/schedule-page.html","<div class=container-fluid translate-namespace=SchedulePage><h3>Schedule page</h3><h5 class=mb-5>User: {{ $ctrl.username }}</h5><div class=\"row row-cols-1 row-cols-sm-2 row-cols-lg-4\"><!-- <div class=\"row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-7 row-cols-xl-4\"> --><div class=\"col mb-4\" ng-repeat=\"userEvent in $ctrl.finalEvents\"><div class=\"card h-100\" ng-class=\"{ \'border-success\': userEvent.active, \'border-dark\': !userEvent.active }\"><div class=\"card-header text-center\" ng-class=\"{ \'bg-success\': userEvent.active }\">{{ userEvent.desc }} {{ userEvent.day }} {{ userEvent.month }} {{ userEvent.year }}</div><!--                 <div class=\"card-body text-dark text-center\">\n                    {{ userEvent.date | date:\'shortDate\' }}\n                </div>\n --><ul class=\"list-group list-group-flush\"><li class=list-group-item ng-repeat=\"orari in userEvent.eventsOfTheDay\"><span class=float-right><i class=\"fas fa-utensils\" ng-if=orari.stomacoPieno uib-tooltip=\"A stomaco pieno\" tooltip-placement=bottom-right></i> <i class=\"fas {{ orari.tipologia.ico }}\" uib-tooltip=\"{{ \'drugTypes.\'+orari.tipologia.desc | translate }}\" tooltip-placement=bottom-right></i> <i class=\"fas fa-book-medical\" uib-tooltip=\"{{ \'SchedulePage.DrugDetail\' | translate }}\" tooltip-placement=bottom-right></i> </span>{{ orari.time }} - {{ orari.farmaco }} <small ng-if=\"orari.alternateName !== null\" class=text-muted><br>{{ orari.alternateName }}</small></li></ul><!-- <div class=\"card-footer text-muted\" ng-class=\"{ \'bg-success\': userEvent.active }\"></div> --></div></div></div></div><div class=container><div class=row><div class=col><h3>Test Slider</h3><div uib-carousel active=active interval=300 no-wrap=false><div uib-slide ng-repeat=\"event in $ctrl.userSchedule\"><div class=carousel-caption><h4>Slide {{event.farmaco}}</h4><p>{{event.eventi[0].dataInizio}}</p></div></div></div></div></div></div>");}]);